// extracted by mini-css-extract-plugin
export default {"contentInnerContainer":"tenant-create_contentInnerContainer__xStlT","item":"tenant-create_item__zli8F"};